/// <amd-module name="Repos/Views/PullRequest/Components/ActivityFeed/ActivityCards/CommitCard" />
import * as React from "react";
import { getReposRoutingService, IReposRoutingService } from "Repos/Common/ReposRoutingService";
import { branchNameToRef, getShortCommitId } from "Repos/Common/Util/Ref";
import { branchToVersionDescriptor } from "Repos/Common/Util/Version";
import { getPullRequestViewService, IPullRequestViewService } from "Repos/Views/PullRequest/PullRequestViewService";
import * as Resources from "Repos/Views/PullRequest/Resources";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { Spinner } from "VSSUI/Spinner";
import { getIdentity, getIdentityComponent, getPropertyValue } from "../Utils/ActivityFeedUtils";
import { ActivityCardSubtle, IActivityCardSharedProps } from "./ActivityCardSubtle";

export class CommitCard extends VssComponent<IActivityCardSharedProps> {
    private prDetailsService: IPullRequestViewService;
    private reposRoutingService: IReposRoutingService;
    private isShim: IReadonlyObservableValue<boolean> | undefined;

    public constructor(props: IActivityCardSharedProps, context: IVssComponentContext) {
        super(props);

        this.prDetailsService = getPullRequestViewService(context.pageContext);
        this.reposRoutingService = getReposRoutingService(context.pageContext);
        this.isShim = props.isShimObservable;
    }

    public render() {
        const { thread } = this.props;

        return (
            <Card className="flex-row flex-grow" contentProps={{ contentPadding: false }}>
                <ActivityCardSubtle createDate={thread.publishedDate}>
                    <Observer isShim={this.isShim}>
                        {(props: { isShim: boolean | undefined }) => {
                            if (props.isShim) {
                                return (
                                    <div className="flex-column body-s">
                                        <Spinner className={"padding-16"} />
                                    </div>
                                );
                            }

                            const identityId = getPropertyValue(this.props.thread, "CodeReviewRefUpdatedByIdentity");
                            const identity = getIdentity(thread, identityId);
                            if (!identity) {
                                return null;
                            }

                            const repo = this.prDetailsService.getSourceRepository();
                            const sourceBranchHref = this.reposRoutingService.getFilesUrl(
                                repo.name,
                                repo.project.name,
                                undefined,
                                branchToVersionDescriptor(this.prDetailsService.getSourceBranch())
                            );

                            const numCommits: number = parseInt(getPropertyValue(thread, "CodeReviewRefNewCommitsCount", "0"));
                            const newCommits: string[] = numCommits > 0 ? getPropertyValue(thread, "CodeReviewRefNewCommits").split(";") : [];

                            const sourceRefName = branchNameToRef(this.prDetailsService.getSourceBranch());
                            let format = Resources.ActivityFeedPushedZero;
                            let commitsElement;

                            if (numCommits === 1) {
                                format = Resources.ActivityFeedPushedOne;

                                const commitHref = this.reposRoutingService.getCommitUrl(repo.name, repo.project.name, newCommits[0], sourceRefName);
                                commitsElement = (
                                    <FormatComponent elementType={null} format={Resources.ActivityFeedCommitAdded}>
                                        <FPSLink href={commitHref}>{getShortCommitId(newCommits[0])}</FPSLink>
                                        <FPSLink href={sourceBranchHref}>{this.prDetailsService.getSourceBranch()}</FPSLink>
                                    </FormatComponent>
                                );
                            } else if (numCommits > 1) {
                                format = Resources.ActivityFeedPushedMany;

                                let commitsAfter;
                                const commitHref = this.reposRoutingService.getCommitUrl(repo.name, repo.project.name, newCommits[0], sourceRefName);

                                if (numCommits > 2) {
                                    const afterHref = this.reposRoutingService.getCommitsUrl(
                                        repo.name,
                                        repo.project.name,
                                        branchToVersionDescriptor(this.prDetailsService.getSourceBranch())
                                    );
                                    commitsAfter = <FPSLink href={afterHref}>{Resources.ActivityFeedMore}</FPSLink>;
                                } else {
                                    const afterHref = this.reposRoutingService.getCommitUrl(
                                        repo.name,
                                        repo.project.name,
                                        newCommits[newCommits.length - 1],
                                        sourceRefName
                                    );
                                    commitsAfter = <FPSLink href={afterHref}>{getShortCommitId(newCommits[newCommits.length - 1])}</FPSLink>;
                                }

                                commitsElement = (
                                    <FormatComponent elementType={null} format={Resources.ActivityFeedMultipleCommitsAdded}>
                                        <FPSLink href={commitHref}>{getShortCommitId(newCommits[0])}</FPSLink>
                                        {commitsAfter}
                                        <FPSLink href={sourceBranchHref}>{this.prDetailsService.getSourceBranch()}</FPSLink>
                                    </FormatComponent>
                                );
                            }

                            return (
                                <div className="flex-column body-s">
                                    <FormatComponent elementType={null} format={format}>
                                        {getIdentityComponent(identity, "activity-card-first-image")}
                                        {numCommits.toString()}
                                    </FormatComponent>
                                    {commitsElement ? commitsElement : null}
                                </div>
                            );
                        }}
                    </Observer>
                </ActivityCardSubtle>
            </Card>
        );
    }
}

Components.add("ms.vss-code-web.commit-activity-card", CommitCard);
